import { useQuery } from '@tanstack/react-query';
import { Row, Col, Card, Statistic, Typography, Spin } from 'antd';
import { CarOutlined, DollarOutlined, ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { carsApi, paymentsApi } from '../api/client';

const { Title } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  .ant-statistic-title {
    font-size: 14px;
    color: #666;
  }
  
  .ant-statistic-content {
    font-size: 28px;
  }
`;

const IconWrapper = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${props => props.$color}15;
  color: ${props => props.$color};
  font-size: 24px;
  margin-bottom: 12px;
`;

export function Dashboard() {
  const { data: carStats, isLoading: carsLoading } = useQuery({
    queryKey: ['carStats'],
    queryFn: async () => {
      const res = await carsApi.getStatistics();
      return res.data.data;
    },
  });

  const { data: paymentStats, isLoading: paymentsLoading } = useQuery({
    queryKey: ['paymentStats'],
    queryFn: async () => {
      const res = await paymentsApi.getStatistics();
      return res.data.data;
    },
  });

  if (carsLoading || paymentsLoading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Title level={3}>Dashboard</Title>
      
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={12} lg={6}>
          <StyledCard>
            <IconWrapper $color="#1677ff">
              <CarOutlined />
            </IconWrapper>
            <Statistic 
              title="Jami e'lonlar" 
              value={carStats?.total || 0} 
            />
          </StyledCard>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <StyledCard>
            <IconWrapper $color="#faad14">
              <ClockCircleOutlined />
            </IconWrapper>
            <Statistic 
              title="Kutayotganlar" 
              value={carStats?.pending || 0} 
              valueStyle={{ color: '#faad14' }}
            />
          </StyledCard>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <StyledCard>
            <IconWrapper $color="#52c41a">
              <CheckCircleOutlined />
            </IconWrapper>
            <Statistic 
              title="Nashr qilingan" 
              value={carStats?.published || 0}
              valueStyle={{ color: '#52c41a' }}
            />
          </StyledCard>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <StyledCard>
            <IconWrapper $color="#722ed1">
              <DollarOutlined />
            </IconWrapper>
            <Statistic 
              title="Jami daromad" 
              value={paymentStats?.revenue || 0}
              suffix="so'm"
              valueStyle={{ color: '#722ed1' }}
            />
          </StyledCard>
        </Col>
      </Row>
    </div>
  );
}
